<script>
	import { onMount } from 'svelte';
	import { IsElectron, Version, UserInfo } from '$lib/store.js';
	import { page } from '$app/stores.js';
	import { goto } from '$app/navigation';
	let redirectString = '',
		app,
		subscriptionSuccess,
		redirect;
	onMount(async () => {
		// if ($IsElectron && $UserInfo.onboardingComplete) {
		// 	goto('/complete');
		// 	return;
		// }sammymiboi+bigtesty@gmail.com
		app =
			$page.url.searchParams.app ||
			($page.url.searchParams.get && $page.url.searchParams.get('app')) ||
			false;
		subscriptionSuccess =
			$page.url.searchParams.subscriptionSuccess ||
			($page.url.searchParams.get && $page.url.searchParams.get('subscriptionSuccess')) ||
			false;

		redirectString = `access_token=${localStorage.ethi_access}&refresh_token=${
			localStorage.ethi_refresh
		}&user_token=${encodeURIComponent(localStorage.userToken)}`;
		if ((app || $Version?.app) == 'omnipilot' || window.location.href.includes('omnipilot')) {
			goto('https://omnipilot.ai/subscribed');
			return;
		}
		redirect = `${
			(app || $Version?.app) == 'omnipilot' || window.location.href.includes('omnipilot')
				? 'omnipilot://'
				: 'magic://'
		}${
			(app || $Version?.app) == 'omnipilot' || window.location.href.includes('omnipilot')
				? 'complete'
				: 'login'
		}?${redirectString}`;
		goto(redirect);
	});
</script>

<div class="absolute centreInContext pb-20 flex flex-col gap-3">
	<h1>Success!</h1>
	You're all set! You should get redirected to the app in a few seconds.
	<div>
		If you don't, <a href={redirect}> <button>click here</button></a>
	</div>
	<div>You can close this window now.</div>
</div>
